export default __webpack_public_path__ + "static/media/egg4.6161f97b.jpg";